import { createContext, useState } from "react";
import { ExerciseEntity } from "src/sources/entities/exercise.entity";
import { ExerciseType } from "src/sources/enums/exercise-type.enum";

export type Exercise = {
  id: number;
  title: string;
  instructions: string;
  initialState: string;
  desiredState: string;
};

export const CurrentExerciseContext = createContext<{
  current: ExerciseEntity;
  setCurrent: (Exercise: ExerciseEntity) => void;
}>({
  current: new ExerciseEntity(0, "", "", "", "", "", ExerciseType.BOTH, 0),
  setCurrent: () => {},
});

export function CurrentExerciseProvider({ children }: React.PropsWithChildren) {
  const [current, setCurrent] = useState<ExerciseEntity>(
    new ExerciseEntity(0, "", "", "", "", "", ExerciseType.BOTH, 0)
  );
  return (
    <CurrentExerciseContext.Provider value={{ current, setCurrent }}>
      {children}
    </CurrentExerciseContext.Provider>
  );
}
